  $(".datepicker").datepicker({
    minDate: 0,
    maxDate: '+1m', 
    onSelect: function(dateText) {
      var date = new Date(dateText);
      var today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
      var selected = new Date(dateText).getTime();
      if (today > selected){
        $('.datepicker').val($.datepicker.formatDate('DD - MM d', date).toLowerCase());
        $(".ProductItem__DeliveryLabel").text("").hide();
      }else if(today < selected){
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        if(date.getDate() == tomorrow.getDate()){
          $('.datepicker').val('tomorrow - ' +$.datepicker.formatDate('MM d', date).toLowerCase());
        }else{
          $('.datepicker').val($.datepicker.formatDate('DD - MM d', date).toLowerCase());
        }
        $(".ProductItem__DeliveryLabel").text("").hide();
      }else{ 
        var d = new Date();
		$('.datepicker').val('today - ' + $.datepicker.formatDate('MM d', date).toLowerCase());
        if(d.getHours() < 12){
          $(".ProductItem__DeliveryLabel").text("Receive On " + $.datepicker.formatDate('MM d', date)).show();
        }else{
          const today = new Date();
          const tomorrow = new Date(today);
          tomorrow.setDate(tomorrow.getDate() + 1);
          $(".ProductItem__DeliveryLabel").text("Receive On " + $.datepicker.formatDate('MM d', tomorrow)).show();
        }
      };
    }
  });

  $("#ProductForm__Datepicker").datepicker({
    minDate: 0,
    maxDate: '+1m', 
    onSelect: function(dateText) {
      var date = new Date(dateText);
      var today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
      var selected = new Date(dateText).getTime();
      if (today > selected){
      }else if(today < selected){
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        if(date.getDate() == tomorrow.getDate()){
          $("#ProductForm__Datepicker").val('tomorrow - ' + $.datepicker.formatDate('MM d', date).toLowerCase());
        }else{
          $("#ProductForm__Datepicker").val($.datepicker.formatDate('DD - MM d', date).toLowerCase());
        }
      }else{ 
		$("#ProductForm__Datepicker").val('today - ' + $.datepicker.formatDate('MM d', date).toLowerCase());
      };
    }
  });